import PropTypes from 'prop-types'
import React from 'react'
import './NoResults.less'

const DEFAULT_SEARCH_TERM = '<search term>'
const DEFAULT_SUGGESTIONS = [
  'check your spelling',
  'try more general keywords',
  'try more general keywords that mean the same thing'
]

const NoResults = ({searchTerm, suggestions}) =>
  <div className='nmc-no-results'>
    <p>sorry, no results found for <strong>{searchTerm || DEFAULT_SEARCH_TERM}</strong></p>
    <p className='nmc-no-results-suggestions'><strong>search suggestions:</strong></p>
    <ul className='nmc-no-results-ul'>
      {
        (suggestions || DEFAULT_SUGGESTIONS).map((suggestion, i) =>
          <li key={i} className='nmc-no-results-li'>{suggestion}</li>
        )
      }
    </ul>
  </div>

NoResults.propTypes = {
  searchTerm: PropTypes.string,
  suggestions: PropTypes.arrayOf((suggestion) => typeof suggestion === 'string')
}

NoResults.defaultProps = {
  searchTerm: DEFAULT_SEARCH_TERM,
  suggestions: DEFAULT_SUGGESTIONS
}

export default NoResults



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/NoResults/index.js